import { ReactNode } from "react";
import img from "../assets/images/placeholder-image.png";
import pdf from "../assets/images/placeholder-pdf.svg";
import { CommonStatus } from "../types/index.type";
import { capitalize } from "../utils/string";

// placeholder
export const IMG = img;
export const PDF = pdf;
export const dateFormat = "YYYY-MM-DD";

export const selectSearchOption = (
  input: string,
  option?: { label: string; value: string | number }
) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

export const addKeyInArray = (data: any) => {
  return data?.map((el: object & { _id?: string }, idx: number) => ({
    ...el,
    key: el?._id || `${idx}`,
  }));
};

export const ArrayOption = (
  data: any[],
  label: string,
  value: string,
  ctz?: boolean
) => {
  return data.map((el) => ({
    label: ctz ? capitalize(el[label]) : el[label],
    value: el[value] || null,
  }));
};

export const changeStatus = (val: string) => {
  switch (val) {
    case "Save as Draft":
      return "Draft";

    default:
      return val;
  }
};

export const StringArrayOption = (data: string[]) => {
  return data.map((el) => ({
    label: changeStatus(el),
    value: el,
  }));
};

export const addKeyInArrayRevereLoginLog = (data: any) => {
  return data
    ?.slice()
    .reverse()
    .map((el: { _id?: string }, idx: number) => ({
      ...el,
      key: el?._id || `${idx}`,
    }));
};

export const returnStringStatus = (val: boolean) => {
  return (val ? "Active" : "Inactive") as CommonStatus;
};

export const returnBooleanStatus = (val: CommonStatus | undefined) => {
  return (val === undefined ? undefined : val === "Active" ? true : false) as
    | boolean
    | undefined;
};

export const checkEmptyValue = (val?: string) => {
  return val && val !== "N/A" ? val : undefined;
};

export const returnNAForEmpty = (val: ReactNode) => {
  return val || "N/A";
};

export const commonStatusClass = {
  Active: "status-done",
  Inactive: "status-danger",
};

export const formatNumber = (num: number) => {
  // Convert the number to a string
  let numStr = num.toString();

  // Split into two parts: before and after the last three digits
  let lastThree = numStr.slice(-3);
  let rest = numStr.slice(0, -3);

  // Add a comma after every two digits in the rest of the string
  if (rest !== "") {
    rest = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ",");
  }

  // Combine the formatted rest with the last three digits
  return rest + (rest ? "," : "") + lastThree;
};

export function formatSouthAsianNumber(number: number = 0) {
  const numStr = number.toString();
  const lastThree = numStr.slice(-3);
  const otherNumbers = numStr.slice(0, -3);

  if (otherNumbers === "") return lastThree;

  return otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + lastThree;
}

// convert underscore to real string with capitalize
export const underscoreToCapitalizeString = (
  str: string,
  smallLetter?: boolean
) => {
  if (smallLetter) return str?.split("_")?.join(" ");
  return capitalize(str?.split("_")?.join(" "));
};

export function customTimeConverter(time12h: any) {
  const [time, modifier] = time12h.split(" ");
  let [hours, minutes, seconds] = time.split(":");

  hours = parseInt(hours, 10);

  // Special case: "12:00:00 PM" → "23:59:59"
  if (time === "12:00:00" && modifier === "PM") {
    return "23:59:59";
  }

  if (modifier === "AM") {
    if (hours === 12) hours = 0; // 12 AM → 00
  } else if (modifier === "PM") {
    if (hours !== 12) hours += 12; // normal PM conversion
  }

  // Format with leading zeros
  return [String(hours).padStart(2, "0"), minutes, seconds].join(":");
}

